<template>
  <span
    @click="opened = !noChange"
    v-if="status"
    class="cursor-pointer inline-block rounded px-2 py-1"
    :class="statusClasses[status]"
  >
    <i class="mr-1" :class="statusIcons[status]"></i>
    {{ statusList[status] }} <span v-if="id">(#{{ id }})</span>
  </span>
  <UIModal v-model="opened" :fixed="fixed" close close-text="Annuler">
    <div>
      <div class="overflow-y-scroll my-2 border rounded-sm border-gray-200" style="max-height: 60vh">
        <ul class="block">
          <li
            v-for="(label, value) in statusList"
            :key="`${value}${label}`"
            @click="() => selectStatus(value)"
            class="cursor-pointer select-none relative py-2 px-3 hover:bg-gray-100 hover:text-gray-800"
          >
            <span :class="[value === status ? 'font-semibold' : 'font-normal', 'block truncate']">
              {{ label }}
            </span>

            <span v-if="value === status" class="text-indigo-600 absolute inset-y-0 right-0 flex items-center pr-4">
              <i class="fas fa-check"></i>
            </span>
          </li>
        </ul>
      </div>
    </div>
  </UIModal>
</template>

<script>
import UIModal from '@/components/UI/Atom/Modal'
import PRODUCTION_STATUS from '@/constants/PRODUCTION_STATUS'
import { ref } from 'vue'

export default {
  props: {
    status: String,
    id: [Number, String],
    fixed: Boolean,
    noChange: Boolean,
  },
  components: {
    UIModal,
  },
  emits: ['change'],
  setup(props, { emit }) {
    const opened = ref(false)
    const statusList = PRODUCTION_STATUS
    const statusClasses = {
      IN_PRODUCTION: 'bg-yellow-300 text-yellow-900',
      WAITING_RESPONSE: 'bg-blue-300 text-blue-900',
      CANCELED: 'bg-red-300 text-red-700',
      COMPLETED: 'bg-green-500 text-white',
    }
    const statusIcons = {
      IN_PRODUCTION: 'fas fa-play',
      WAITING_RESPONSE: 'fas fa-pause-circle',
      CANCELED: 'fas fa-times-circle',
      COMPLETED: 'fas fa-check',
    }
    const selectStatus = value => {
      emit('change', value)
      opened.value = false
    }
    return { opened, statusList, statusClasses, statusIcons, selectStatus }
  },
}
</script>

<style></style>
